import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import Header from "../../global/Header";
import Footer from "../../global/Footer";
import { ReactComponent as GroupLogo } from "../../data/svg/6334.svg";
import { ReactComponent as AnalyticsLogo } from "../../data/svg/6A.svg";
import { ReactComponent as AcademyLogo } from "../../data/svg/6334Academy.svg";
import Heading from "../../components/Heading";
import Essay from "../../components/Essay";
import ButtonBar from "../../components/ButtonBar";
import Section from "../../components/Section";
import TeamProfile from "../../components/TeamProfile";
import { customColour } from "../../data/colour";
import {
  dark,
  light,
  isTabWidth,
  teamIntroHeading,
  teamIntroEssay,
  teamHeaderButtons,
  teamPicture,
  teamProfiles,
  menuItems,
} from "../../data/database";

const linkLogo = [
  {
    label: "Academy",
    LinkLogoSvg: AcademyLogo,
    link: "/academy/home",
  },
  {
    label: "Analytics",
    LinkLogoSvg: AnalyticsLogo,
    link: "/analytics/home",
  },
];

const GroupTeam = () => {
  const isTab = useMediaQuery(isTabWidth);
  return (
    <>
      {/* HERO SECTION */}
      <Box
        sx={{
          position: "relative",
          height: `${isTab ? "40vh" : "65vh"}`,
          overflow: "hidden",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: `${teamPicture}`,
        }}
      >
        <Box
          sx={{
            width: "80%",
            position: "absolute",
            top: `${isTab ? "30%" : "40%"}`,
            left: "50%",
            color: customColour.white,
            transform: "translate(-50%, 0)",
          }}
        >
          <Heading
            heading={teamIntroHeading}
            fontSize={isTab ? "1.25rem" : "3rem"}
            fontweight={isTab ? "700" : "200"}
          />
          <Essay
            paragraphs={teamIntroEssay}
            textAlign={isTab ? "center" : "center"}
            fontSize={isTab ? "0.9rem" : "1rem"}
            marginTop={isTab ? "0.25rem" : "1rem"}
          />
          <Box sx={{ width: `${isTab ? "100%" : "50%"}`, margin: "auto" }}>
            <ButtonBar
              buttons={teamHeaderButtons}
              fontSize={isTab ? "0.9rem" : "1rem"}
              gap={isTab ? "0.75rem" : "2rem"}
              background="linear-gradient(
              to right bottom,
              rgba(0, 0, 0, 0.9),
              rgba(0, 0, 0, 0.7)
              )"
            />
          </Box>
        </Box>
      </Box>

      {/* TEMP BODY Light */}
      <Section
        backgroundColor={customColour.darkBackground}
        image={dark}
        color={customColour.white}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={teamIntroHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "700" : "200"}
        />
        <Essay
          paragraphs={teamIntroEssay}
          textAlign={isTab ? "center" : "center"}
          fontSize={isTab ? "0.9rem" : "1rem"}
          marginTop={isTab ? "0.25rem" : "1rem"}
        />
        <TeamProfile
          data={teamProfiles}
          nameTextSize={isTab ? "1rem" : "1.5rem"}
          subTextSize={isTab ? "0.6rem" : "0.75rem"}
        />
      </Section>
    </>
  );
};

export default GroupTeam;
